<template>
  <time-serie-chart
    class="box-height-100"
    title="Active sessions"
    :timer="timer"
    :xAxis="xAxis"
    :data1="data1"
    :data2="data2"
    :data3="data3"
    :view-type="viewType"
  />
</template>
<script>
import Moment from 'moment'
import apiRealtime from '@/apis/realtime'

import TimeSerieChart from '@/components/echart/time_serie'

export default {
  components: {
    TimeSerieChart
  },
  props: {
    refresh: Boolean,
    direction: String,
    viewType: String
  },
  watch: {
    refresh: {
      immediate: true,
      handler(val) {
        if (val) this.getConcurrent()
      }
    }
  },
  data() {
    return {
      timer: 0,
      interval: null,
      now: null,
      xAxis: [],
      data1: {
        name: 'Max calls',
        type: 'line',
        showSymbol: false,
        lineStyle: {
          color: this.$getVoiceColor[0],
          type: 'dotted'
        },
        data: []
      },
      data2: {
        name: 'Calls',
        type: 'line',
        showSymbol: false,
        lineStyle: {
          color: this.$getVoiceColor[0]
        },
        data: []
      },
      data3: {
        name: 'Chats',
        type: 'line',
        showSymbol: false,
        lineStyle: { color: this.$getChatColor[0] },
        data: []
      },
      tmpValue1: 0,
      tmpValue2: 0,
      tmpValue3: 0
    }
  },
  beforeDestroy() {
    if (this.interval) clearInterval(this.interval)
  },
  methods: {
    async getConcurrent() {
      try {
        const data = await apiRealtime.getConcurrent({
          direction: this.direction
        })
        // this.xAxis = []
        this.data1.data = []
        this.data2.data = []
        this.data3.data = []

        for (let i = 0; i < data.data.length; i++) {
          const value = data.data[i]

          // this.xAxis.push(value.day)
          this.data1.data.push([value.time, value.maxVoice])
          this.data2.data.push([value.time, value.voice])
          this.data3.data.push([value.time, value.chat])

          this.tmpValue1 = value.maxVoice
          this.tmpValue2 = value.voice
          this.tmpValue3 = value.chat
        }

        if (this.timer === 0) {
          this.now = Moment().startOf('minute')

          this.interval = setInterval(() => {
            this.now = Moment.utc(+this.now + 60 * 1000)
            const format = Moment(this.now)
              .utc()
              .toISOString()

            this.data1.data.shift()
            this.data2.data.shift()
            this.data3.data.shift()

            this.data1.data.push([format, this.tmpValue1])
            this.data2.data.push([format, this.tmpValue2])
            this.data3.data.push([format, this.tmpValue3])

            this.timer += 1
          }, 60 * 1000)
        }
        this.timer += 1

        this.$emit('reset', 'timeSerieActive')
      } catch (error) {}
    }
  }
}
</script>
